import { render, staticRenderFns } from "./modalDescripcionLeecheros.vue?vue&type=template&id=1faebc20&"
import script from "./modalDescripcionLeecheros.vue?vue&type=script&lang=js&"
export * from "./modalDescripcionLeecheros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports